export enum ExportDashboardType {
  Email = `email`,
  Slack = `slack`,
}

export const enum LoadingStatus {
  Idle = `idle`,
  Success = `success`,
  Failed = `failed`,
  Pending = `pending`,
}

export type LoadingState<T> = {
  loading: LoadingStatus;
  data: T;
  error: Error;
};

export const LOADING_STATES = [LoadingStatus.Pending, LoadingStatus.Idle];
